import { useFormContext, Controller } from 'react-hook-form';
import { IoMdStar } from 'react-icons/io';
import { useState } from 'react';

const StarRatingInput = () => {
    const { control, formState: { errors } } = useFormContext();
    const [hoveredStar, setHoveredStar] = useState(0);

    const getStarColor = (activeStar, currentStar) => {
        if (activeStar >= currentStar) {
            if (activeStar <= 2) return 'text-red-500';
            if (activeStar === 3) return 'text-yellow-400';
            return 'text-green-500';
        }
        return 'text-gray-300';
    };

    return (
        <div>
            <label className="block text-[#072320] font-dm text-lg capitalize font-medium mb-2">
                Rating <span className="text-red-500">*</span>
            </label>

            <Controller
                control={control}
                name="rating"
                render={({ field: { value, onChange } }) => {
                    const activeValue = hoveredStar || value;

                    return (
                        <div className="flex space-x-1">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <IoMdStar
                                    key={star}
                                    className={`text-3xl cursor-pointer transition ${getStarColor(activeValue, star)}`}
                                    onClick={() => {
                                        onChange(star);
                                        setHoveredStar(0);
                                    }}
                                    onMouseEnter={() => setHoveredStar(star)}
                                    onMouseLeave={() => setHoveredStar(0)}
                                />
                            ))}
                        </div>
                    );
                }}
            />
            {errors.rating && (
                <p className="text-red-500 text-sm mt-1">{errors.rating.message}</p>
            )}
        </div>
    );
};

export default StarRatingInput;
